import useTranslations from '@/i18n/useTranslations';
import LocationIcon from '@/shared-components/icons/components/user-profile/LocationIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/DisplayLocation.css';

export default function DisplayLocation({ userLocation }) {
  const t = useTranslations('common.profile.location');
  if(!userLocation) {
    return <></>;
  }

  return (
    <>
      <div className="profile-info__display-location-container element-non-selectable">
        <a 
          href={`https://maps.google.com/?q=${userLocation}`} 
          className="profile-info__display-location-link" 
          aria-label={t('aria.user_location')} 
          target="_blank" 
          rel="noreferrer"
        >
          <LocationIcon className="profile-info__display-location-icon"/>

          <Text
            className="profile-info__display-location-text font-size-medium"
            paragraph>
            {userLocation}
          </Text>
        </a>
      </div>
    </>
  );
}
